import React, { useRef } from "react";
import ListCalendar from "./ListCalendar";
import StaticReservationList from "./StaticReservationList2";
import { Macros } from "../models/Macros";
import { useAppContext } from "../contexts/AppContext";
import { TListCalendarWrapperProps } from "../types/components/ListCalendarWrapper";

type TStaticReservationListCalendarProps = {
    id: number;
    onInfoOpen: (entryIds: number[], showPanel?: boolean) => void;
} & TListCalendarWrapperProps;

const getRefreshEvents = () => [
    Macros.Event.SELECT_RESERVATION,
    Macros.Event.RESERVATION_MADE_OR_MODIFIED,
    Macros.Event.RESERVATION_RESTORED,
];

const StaticReservationListCalendar = (props: TStaticReservationListCalendarProps) => {
    const appContext = useAppContext();
    const wrapper = useRef<any>(null);

    const onSelection = (selection) => {
        if (!selection.cancelled) {
            appContext.fireEvent(
                `staticReservationList${props.id}`,
                Macros.Event.SELECT_RESERVATION,
                selection
            );
            props.onInfoOpen([selection.id], false);
        }
    };

    return (
        <ListCalendar
            {...props}
            className={`${props.className} staticReservationList`}
            type={"staticReservationList"}
            refreshEvents={getRefreshEvents()}
            onSelection={onSelection}
            listRef={(node) => {
                wrapper.current = node;
            }}
        >
            <StaticReservationList />
        </ListCalendar>
    );
};

export default StaticReservationListCalendar;
